import React from "react";

const SubmitButton = ({
  disabled,
  enabledLabel,
  disabledLabel,
  width = "",
  borderColor = "",
  textColor = "",
  backgroundColor = "",
  hoverBackgroundColor = "",
  focusRingColor = "",
  disabledOpacity = "",
}) => {
  return (
    <button
      type="submit"
      disabled={disabled}
      // className={`${buttonClassName} ${className}`}
      className={`group relative ${width} flex justify-center py-2 px-4 border ${borderColor} text-sm font-medium rounded-md ${textColor} ${backgroundColor} ${hoverBackgroundColor} focus:outline-none focus:ring-2 focus:ring-offset-2 ${focusRingColor} disabled:opacity-${disabledOpacity}`}
    >
      {disabled ? (
        <span className="flex items-center">
          <svg
            className="animate-spin -ml-1 mr-2 h-4 w-4 text-white"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
          >
            <circle
              className="opacity-25"
              cx="12"
              cy="12"
              r="10"
              stroke="currentColor"
              strokeWidth="4"
            ></circle>
            <path
              className="opacity-75"
              fill="currentColor"
              d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
            ></path>
          </svg>
          {disabledLabel}
        </span>
      ) : (
        enabledLabel
      )}
    </button>
  );
};

export default SubmitButton;
